import get from 'lodash/get';

export const Faq = (item) => ({
  id: get(item, 'id') || '',
  title: get(item, 'title') || '',
  description: get(item, 'description') || ''
});